<script>
  import AddList from "./AddList.svelte";

  import { v4 } from "uuid";
  export let channels = [];
  import changesStore from "../../stores/Changes";
  import { languages } from "../../assets/GeoData";
  import Validators from "../../utils/validators";

  const ChannelFields = [
    {
      type: "auto",
      name: "id",
      label: "Channel ID",
      disabled: true,
      placeholder: "Auto-Generated ID",
    },
    {
      type: "text",
      name: "name",
      label: "Channel Name",
      readonlyValue: true,
      placeholder: "Channel Name",
      validations: [Validators.required("Channel Name is required")],
    },
    {
      type: "combo",
      name: "language",
      items: languages,
      isClearable: false,
      label: "Language",
      validations: [Validators.required("Language is required")],
    },
  ];

  function onAddRow(dataObj) {
    const newChannel = { ...dataObj, id: String(new Date().getTime()) };
    changesStore.upsert("channels", newChannel, true);
    if (newChannel.language?.value)
      newChannel.language = newChannel.language.value;
    channels.push(newChannel);
    return channels;
  }
  function onUpdateRow(i, field, data) {
    data = data?.value || data;
    //console.log(channels[i][field], data);
    if (channels[i][field] != data) {
      channels[i][field] = data;
      changesStore.upsert("channels", channels[i], false);
    }
  }
  function onDeleteRow(i) {
    const [deletedChannel] = channels.splice(i, 1);
    //console.log(deletedChannel);
    changesStore.delete("channels", deletedChannel.id);
    return channels;
  }
</script>

<AddList
  name="channels"
  fields={ChannelFields}
  data={channels}
  {onAddRow}
  {onDeleteRow}
  {onUpdateRow}
/>
